import { render, staticRenderFns } from "./follow-share.vue?vue&type=template&id=0211d0ce&scoped=true&"
import script from "./follow-share.vue?vue&type=script&lang=js&"
export * from "./follow-share.vue?vue&type=script&lang=js&"
import style0 from "./follow-share.vue?vue&type=style&index=0&id=0211d0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0211d0ce",
  null
  
)

export default component.exports